import { Card, Image } from "react-bootstrap";
import styles from "./SendWaterBodyUpdates.module.css";
import cn from 'classnames';
import { ASSESTS } from "../../../constant/assest";
import CustomButton, { ButtonRadiusSize, ButtonSize, ButtonType } from "../../common/CustomButton/CustomButton";
import FormField, { IFieldTheme, IFieldType } from "../../common/FormField/FormField";
import FormTextarea from "../../common/FormField/FormTextArea";

interface ISendWaterBodyUpdatesProps {
    className?: string;
};

const SendWaterBodyUpdates: React.FC<ISendWaterBodyUpdatesProps> = ({className}) => {

    const renderUpdateItem = (label: string, value: string, className?: string) => {
        return (
            <div className={cn(styles.updateItem, className)}>
                <div className={styles.label}>{label}</div>
                <div className={styles.value}>{value}</div>
            </div>
        );
    };
  

  return (
    <Card bsPrefix={cn(styles.sendWaterBodyUpdatesCard, className)}>
      <Card.Header bsPrefix={styles.header}>
        <Card.Title bsPrefix={styles.title} as={'div'}>
            <Image src={ASSESTS.TABLERSEND} alt={'Send Water Body Updates'} width={23} height={23} /> Send Water Body Updates
        </Card.Title>
        <Card.Text bsPrefix={styles.text} as={'div'}>Compose and send updates about selected water bodies to targeted users</Card.Text>
      </Card.Header>
      <Card.Body bsPrefix={styles.body}>
        <div className={styles.updateForm}>
            <FormField 
                label="Update Title"
                fieldType={IFieldType.TEXT}
                fieldTheme={IFieldTheme.LIGHT2}
                placeholder="Eg. Crystal Lake"
            />
            <FormTextarea 
                label="Message"
                fieldTheme={IFieldTheme.LIGHT2}
                placeholder="Share details about the water body updates, near fish species, or fishing conditions."
            />
        </div>
        <div className={styles.updateDetail}>
            <div className={styles.detailTitle}>Update Summary</div>
            <div className={styles.detailBox}>
                {renderUpdateItem('Selected Water Bodies:', '4')}
                {renderUpdateItem('Target Radius:', '30 miles')}
                {renderUpdateItem('Target Cities:', 'NewYork, Seatle, Miami, Denver..')}
                {renderUpdateItem('Target Zones:', 'Central , SouthWest')}
                {renderUpdateItem('Estimated Reach:', '25000', styles.updateReachItem)}
            </div>
        </div>
      </Card.Body>
      <Card.Footer bsPrefix={styles.footer}>
        <CustomButton 
            btnType={ButtonType.GREEN}
            btnRadius={ButtonRadiusSize.SMALL}
            btnSize={ButtonSize.SMALL}
            onClick={() => {}}
        >
             Send Update
        </CustomButton>
      </Card.Footer>
    </Card>
  );
};

export default SendWaterBodyUpdates;
